import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useCallback, useState } from 'react';
import { SearchDialogAnalyticsContext } from '../../common/analytics';
import { useFilter, addFilters as addFiltersAction, updateFilterState, replaceAllFilters as replaceAllFiltersAction } from '../../common/filters/use-filters';
import { FilterOptionSource } from '../../common/filters/types';
import { messages } from '../../messages';
import { getDateXDaysBack } from '../utils/jira-search-dialog-functions';
var BROCCOLI_30_EXPERIMENT = {
  experimentId: 'broccoli-30-frontend',
  days: 30
};
var BROCCOLI_60_EXPERIMENT = {
  experimentId: 'broccoli-60-frontend',
  days: 60
};
var BROCCOLI_90_EXPERIMENT = {
  experimentId: 'broccoli-90-frontend',
  days: 90
};
export var BROCCOLI_EXPERIMENTS = [BROCCOLI_30_EXPERIMENT, BROCCOLI_60_EXPERIMENT, BROCCOLI_90_EXPERIMENT];
export var BinaryStatusCategory = /*#__PURE__*/_createClass(function BinaryStatusCategory(id, jqlValue) {
  _classCallCheck(this, BinaryStatusCategory);
  this.id = id;
  this.jqlValue = jqlValue;
});
_class = BinaryStatusCategory;
_defineProperty(BinaryStatusCategory, "OPEN", new _class('open', '"undefined", "In Progress", "To Do"'));
_defineProperty(BinaryStatusCategory, "DONE", new _class('done', '"Done"'));
export var DEFAULT_BINARY_STATUS_CATEGORY_FILTERS = [{
  title: messages.binary_status_category_filter_option_open,
  id: BinaryStatusCategory.OPEN.id,
  isChecked: false,
  isVisible: true,
  filterSource: FilterOptionSource.STATIC
}, {
  title: messages.binary_status_category_filter_option_done,
  id: BinaryStatusCategory.DONE.id,
  isChecked: false,
  isVisible: true,
  filterSource: FilterOptionSource.STATIC
}];
export var useFilters = function useFilters() {
  var defaultFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useFilter = useFilter(defaultFilters),
    filters = _useFilter.filters,
    dispatch = _useFilter.dispatch;
  var addFilters = useCallback(function (newFilters) {
    return dispatch(addFiltersAction(newFilters, function (a, b) {
      if (a.filterSource === FilterOptionSource.CURRENT_USER && b.filterSource !== FilterOptionSource.CURRENT_USER) {
        return -1;
      }
      if (a.filterSource !== FilterOptionSource.CURRENT_USER && b.filterSource === FilterOptionSource.CURRENT_USER) {
        return 1;
      }
      return 0;
    }));
  }, [dispatch]);
  var updateFilter = useCallback(function (id, isChecked) {
    return dispatch(updateFilterState(id, isChecked, true));
  }, [dispatch]);
  var clearFilter = useCallback(function () {
    filters.forEach(function (f) {
      return dispatch(updateFilterState(f.id, false));
    });
  }, [filters, dispatch]);
  var resetFilter = useCallback(function () {
    dispatch(replaceAllFiltersAction(defaultFilters));
  }, [defaultFilters, dispatch]);
  return {
    availableFilters: filters,
    addFilters: addFilters,
    updateFilter: updateFilter,
    clearFilter: clearFilter,
    reset: resetFilter,
    dispatch: dispatch
  };
};
var DEFAULT_FILTER_STATE = {
  availableFilters: [],
  addFilters: function addFilters() {},
  updateFilter: function updateFilter() {},
  clearFilter: function clearFilter() {},
  reset: function reset() {},
  dispatch: function dispatch() {}
};
var FilterContext = /*#__PURE__*/createContext({
  projectFilters: DEFAULT_FILTER_STATE,
  assigneeFilters: DEFAULT_FILTER_STATE,
  siteFilters: DEFAULT_FILTER_STATE,
  binaryStatusCategoryFilters: DEFAULT_FILTER_STATE,
  dateFilterFrom: {
    value: '',
    setValue: function setValue(_value) {
      return null;
    }
  },
  dateFilterTo: {
    value: '',
    setValue: function setValue(_value) {
      return null;
    }
  }
});
export function transformFiltersForAnalytics(availableFilters) {
  var appliedFilters = availableFilters.map(function (availableFilter, index) {
    return _objectSpread(_objectSpread({}, availableFilter), {}, {
      index: index
    });
  }).filter(function (filterWithIndex) {
    return filterWithIndex.isChecked;
  });
  return {
    applied: appliedFilters.map(function (appliedFilter) {
      return {
        id: appliedFilter.id,
        source: appliedFilter.filterSource,
        index: appliedFilter.index
      };
    }),
    recommendedIds: availableFilters.map(function (appliedFilter) {
      return {
        id: appliedFilter.id,
        source: appliedFilter.filterSource
      };
    })
  };
}
var transformDateFiltersForAnalytics = function transformDateFiltersForAnalytics(dateFilterFrom) {
  var availiableFilters = BROCCOLI_EXPERIMENTS.map(function (experiment) {
    return experiment.days;
  }).map(function (days) {
    return [days, getDateXDaysBack(days)];
  });
  var appliedFilter = availiableFilters.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      date = _ref2[1];
    return date === dateFilterFrom;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      days = _ref4[0],
      _ = _ref4[1];
    return {
      id: days
    };
  });
  return {
    applied: appliedFilter.map(function (_ref5) {
      var id = _ref5.id;
      return {
        id: id,
        source: FilterOptionSource.STATIC
      };
    }),
    recommendedIds: availiableFilters.map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        days = _ref7[0],
        _ = _ref7[1];
      return {
        id: days,
        source: FilterOptionSource.STATIC
      };
    })
  };
};
export var FilterContextProvider = function FilterContextProvider(_ref8) {
  var _ref8$isEnabled = _ref8.isEnabled,
    isEnabled = _ref8$isEnabled === void 0 ? true : _ref8$isEnabled,
    defaultProjectFilters = _ref8.defaultProjectFilters,
    defaultAssigneeFilters = _ref8.defaultAssigneeFilters,
    defaultSiteFilters = _ref8.defaultSiteFilters,
    children = _ref8.children;
  var previousEnabledState = React.useRef(isEnabled);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dateFilterFrom = _useState2[0],
    setDateFilterFrom = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    dateFilterTo = _useState4[0],
    setDateFilterTo = _useState4[1];
  var projectFilterStore = useFilters(defaultProjectFilters);
  var assigneeFilterStore = useFilters(defaultAssigneeFilters);
  var siteFilterStore = useFilters(defaultSiteFilters);
  var binaryStatusCategoryFilterStore = useFilters(DEFAULT_BINARY_STATUS_CATEGORY_FILTERS);
  var filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
    projects: transformFiltersForAnalytics(projectFilterStore.availableFilters),
    assignees: transformFiltersForAnalytics(assigneeFilterStore.availableFilters),
    binaryStatusCategories: transformFiltersForAnalytics(binaryStatusCategoryFilterStore.availableFilters),
    dateFrom: transformDateFiltersForAnalytics(dateFilterFrom)
  };

  // We reset the state when the component becomes disabled
  if (previousEnabledState.current && !isEnabled) {
    projectFilterStore.reset();
    assigneeFilterStore.reset();
    siteFilterStore.reset();
    binaryStatusCategoryFilterStore.clearFilter();
    setDateFilterFrom('');
    setDateFilterTo('');
  }
  previousEnabledState.current = isEnabled;
  return /*#__PURE__*/React.createElement(FilterContext.Provider, {
    value: {
      projectFilters: projectFilterStore,
      assigneeFilters: assigneeFilterStore,
      siteFilters: siteFilterStore,
      binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
      dateFilterFrom: {
        value: dateFilterFrom,
        setValue: setDateFilterFrom
      },
      dateFilterTo: {
        value: dateFilterTo,
        setValue: setDateFilterTo
      }
    }
  }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
    analyticContext: {},
    nonPrivacySafeAnalyticContext: {},
    filterAnalyticsContext: filtersAnalyticsContext
  }, children));
};
export var useFilterContext = function useFilterContext() {
  var filterContext = React.useContext(FilterContext);
  return filterContext;
};